import React from 'react'
import ReactDOM from 'react-dom/client'
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { YbugProvider } from 'ybug-react'
import mixpanel from 'mixpanel-browser'

import './index.css'
import App from './App'
import en from './i18n/en.json'
import de from './i18n/de.json'
// import reportWebVitals from './reportWebVitals'
import { AuthProvider } from './common/context/AuthContext'

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: {
      'en-CA': ['en'],
      'de-DE': ['de'],
    },
    supportedLngs: ['de', 'en', 'de-DE', 'en-CA'],
    debug: process.env.NODE_ENV === 'development',
    resources: {
      de,
      en,
    },
  })
mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
  debug: process.env.NODE_ENV === 'development',
  track_pageview: true,
  persistence: 'localStorage',
  ignore_dnt: true,
})
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <YbugProvider ybugId={process.env.REACT_APP_YBUG_ID}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </YbugProvider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log)
